"use strict";
import {onFind} from "../libs/@elements/init-modules-in-scope";
import {on, hasClass, addClass, removeClass, find, findIn, closest, removeAttribute} from "../libs/@elements/dom-utils";
import {activateScrollLock, deactivateScrollLock} from "../libs/@elements/scroll-lock";

let isOpen;
let currentScrollPosition = 0;
let lastChangedCollapse; //collapse which is changed last
let offsetOfLastChangedCollapse = 0;

export function init () {
    onFind('.js-overlay', function (overlayElement) {
        let isInProductGrid = closest('.js-product-grid__form', overlayElement),
            scrollContent = findIn('.js-overlay__scroll-body', overlayElement);

        if (isInProductGrid && isOpen) {
            addClass('no-transition', overlayElement);
            addClass('is-open', overlayElement);
        }

        on('scroll', function (evt) {
            currentScrollPosition = evt.target.scrollTop;

        }, scrollContent);

        if (isInProductGrid) {
            on('change', function (evt) {
                let collapseWrapper =  closest('.js-product-grid__filter-collapse-target', evt.target);
                let collapseId = collapseWrapper.getAttribute('id');
                lastChangedCollapse = `#${collapseId}`;
                offsetOfLastChangedCollapse = collapseWrapper.getBoundingClientRect().top;

            }, overlayElement);

            on('product-grid.changed', function () {
                removeAttribute('hidden', findIn('.js-overlay__loading', overlayElement))

            }, closest('.js-product-grid', overlayElement));

            on('product-grid.success', function () {
                let lastChangedCollapseTemp = findIn(lastChangedCollapse, scrollContent);
                let newOffset = (typeof lastChangedCollapse === 'undefined') ? 0 : lastChangedCollapseTemp.getBoundingClientRect().top - offsetOfLastChangedCollapse;

                scrollContent.scrollTop = currentScrollPosition + (newOffset - currentScrollPosition)
            }, closest('.js-product-grid', overlayElement));
        }
    });

    onFind('.js-overlay__toggle', function (item) {
        on('click', function () {
            let target = find(item.getAttribute('data-target'));

            if (hasClass('is-open', target)) {
                removeClass('is-open', target);
                deactivateScrollLock();
                isOpen = false;
            } else {
                addClass('is-open', target);
                activateScrollLock();
                isOpen = true;
            }

        }, item);
    });
}
